export const SENDOUT_INTERVIEW_FORM_FIELDS_MAP = {
  SendEmailToCandidate: { key: 'sendEmailToCandidate' },
  SendEmailToHiringAuthority: { key: 'sendEmailToHiringAuthority' }
};
